import { LandingFooter } from "@/components/landing/cta";
import { MissionBrand } from "@/components/mission-chrome";
import { PRIVACY_HEADING, PRIVACY_SECTIONS, PRIVACY_UPDATED } from "../../worker/privacy-policy";
import { Link } from "react-router-dom";

export function PrivacyPage() {
  return (
    <div className="mission-surface relative h-full min-h-0 overflow-y-auto overflow-x-hidden bg-black text-[#f0f0fa]">
      <header className="sticky top-0 z-20 flex h-[72px] items-center gap-6 border-b border-white/10 bg-black/80 px-6 backdrop-blur-md sm:px-10">
        <Link to="/" className="no-underline">
          <MissionBrand />
        </Link>
        <div className="flex-1" />
        <Link
          to="/privacy"
          rel="privacy-policy"
          className="text-[12px] tracking-[0.08em] text-white uppercase no-underline"
        >
          Privacy
        </Link>
        <Link
          to="/"
          className="text-[12px] tracking-[0.08em] text-white/72 uppercase no-underline hover:text-white"
        >
          Home
        </Link>
      </header>
      <main className="mx-auto max-w-[720px] px-6 py-10 sm:px-10 sm:py-14">
        <p className="mb-3 text-[11px] font-semibold tracking-[0.16em] text-white/50 uppercase">
          pcbx.ai · rscircuit Team Platform
        </p>
        <h1 className="m-0 text-[32px] leading-[1.1] font-bold tracking-[-0.02em] text-white sm:text-[40px]">
          {PRIVACY_HEADING}
        </h1>
        <p className="mt-3 text-[13px] text-white/50">Effective {PRIVACY_UPDATED}</p>
        {PRIVACY_SECTIONS.map((section) => (
          <section key={section.id} id={section.id} className="mt-10">
            <h2 className="m-0 text-[18px] font-semibold text-white">{section.heading}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph} className="mt-3 text-[15px] leading-[1.6] text-white/78">
                {paragraph}
              </p>
            ))}
            {section.bullets?.length ? (
              <ul className="mt-3 list-disc space-y-2 pl-5 text-[15px] leading-[1.6] text-white/78">
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </main>
      <LandingFooter />
    </div>
  );
}
